import { Port } from '../../../types/ViewModel/Port';
import { Terminal } from '../../../types/ViewModel/Terminal';
import { TimeZoneFactory } from '../../TimeZoneFactory';
import { TerminalFactory } from '../../TerminalFactory';
import { PortBM } from '../../../types/BusinessModel/PortBM';
import { CountryBM } from '../../../types/BusinessModel/CountryBM';
import { Country } from '../../../types/ViewModel/Country';
import { ReportLocationEnum } from '../../../enums/reportLocationEnum';

const terminalFactory = new TerminalFactory();
const timeZoneFactory = new TimeZoneFactory();

export const newPort = (port: PortBM, country: CountryBM | null, delta: number): Port | null => {
    const terminalArray: Terminal[] = [];
    if (port && port.terminalList && port.terminalList.length > 0) {
        port.terminalList.map((terminal) => {
            const newTerminal = terminalFactory.newTerminal(terminal, null);
            if (newTerminal) {
                terminalArray.push(newTerminal);
            }
        });
    }
    if (port) {
        const newPortObj = new Port(
            port.portId,
            port.portName,
            port.portCluster?.portClusterName,
            country,
            terminalArray,
            timeZoneFactory.newTimeZoneArray(port.timeZoneList),
            port.isEuMrvPort
        );
        newPortObj.deltaInSecondsOnMachine = delta;
        return newPortObj;
    }
    return null;
};

export const newPortFromCode = (port: Port | null, country: Country | null, delta: number): Port | null => {
    const terminalArray: Terminal[] = [];
    if (port && port.terminalArray && port.terminalArray.length > 0) {
        port.terminalArray.map((terminal) => {
            const newTerminal = terminalFactory.newTerminalFromCode(terminal, null);
            if (newTerminal) {
                terminalArray.push(newTerminal);
            }
        });
    }
    if (port) {
        const newPortObj = new Port(
            port.portId,
            port.portName,
            port.portClusterName,
            country,
            terminalArray,
            timeZoneFactory.newTimeZoneArrayFromCode(port.timeZoneArray),
            port.isEuMrvPort
        );
        newPortObj.deltaInSecondsOnMachine = delta;
        return newPortObj;
    }
    return null;
};

export const getPortName = (port: Port | null, eventTypeContextId: ReportLocationEnum): string | null => {
    if (eventTypeContextId === ReportLocationEnum.Sea) return 'At Sea';
    return port ? (port.portClusterName ? port.portClusterName?.toUpperCase() : port.portName) : null;
};
